import { Routes } from '@angular/router';
import { AccountsPageComponent } from './pages/accounts-page/accounts-page.component';
import {CustomersComponent} from './pages/customers-page/customers.component';

export const routes: Routes = [
  { path: '', redirectTo: 'accounts', pathMatch: 'full' },
  { path: 'accounts', component: AccountsPageComponent },
  { path: 'customers', component: CustomersComponent }
];
